// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"c23b42fa","534":"1a078c16","540":"fdf2d81d","854":"ef9423d7"}[chunkId] + ".chunk.css";
};